/**
 * Controller for the QuestionHeadline directive.
 * This class handles the initialization and logic for the question headline in the application.
 */
export class QuestionHeadlineController {
    /**
     * Constructor for QuestionHeadlineController.
     * @param {Object} $scope - Angular scope object.
     * @param {Object} $element - Angular element object.
     * @param {Object} $bridges - Bridges service.
     * @param {Object} TaskDataService - Task data service.
     * @param {Object} $config - Configuration service.
     * @param {Object} $routeParams - Route parameters.
     * @param {Object} TaskInfoService - Task information service.
     * @param {Object} $translate - Translation service.
     * @param {Object} $signals - Signals service.
     */
    constructor($scope, $element, $bridges, TaskDataService, $config, $routeParams, TaskInfoService, $translate, $signals) {
        this.$scope = $scope;
        this.$config = $config;
        this.$routeParams = $routeParams;
        this.TaskInfoService = TaskInfoService;
        this.$translate = $translate;
        this.$signals = $signals;
        this.$logger = $bridges.logger();

        $scope.isPDFMode = $config.isPDFMode();
        $scope._logIdentifier = 'QuestionHeadlineDirective';

        const taskInfo = TaskInfoService.getTaskInfo();
        $scope.writingDirection = taskInfo.getInputLanguage().writingDirection;

        const context = TaskDataService.fetchContext();
        const question = context.read($scope.question);
        const sheetUUID = $routeParams.sheetUUID;
        const sheet = angular.isUUID(sheetUUID) ? context.read(sheetUUID) : null;

        $scope.langISO = taskInfo.getISOInputLanguageCode();
        $scope.sheet = sheet;
        $scope.questionModel = question;
        $scope.showQuestionHeadline = sheet && sheet.isUseQuestionParts() ? true : false;

        $scope.isPreviewMode = $config.isPreviewMode();
        $scope.isCMS = isCMS;
        if (isCMS) {
            $scope.getQuestionItemGroup = this.getQuestionItemGroup.bind(this);
        }

        $scope.checkLanguageAndChangeTitle = this.checkLanguageAndChangeTitle.bind(this);

        $scope.statusString = $scope.questionModel.getStatusString();

        this._handleModelChange = () => {
            $scope.$evalAsync(() => {
                $scope.statusString = $scope.questionModel.getStatusString();
            });
        };
        $signals.on(IB.Signals.MODELCHANGE, this._handleModelChange);
        $scope.$on('$destroy', () => {
            $signals.remove(IB.Signals.MODELCHANGE, this._handleModelChange);
        });
    }

    /**
     * Retrieves the question item group.
     * @returns {Object} The question item group.
     */
    getQuestionItemGroup() {
        return this.$scope.questionModel.getQuestionItemGroup();
    }

    /**
     * Checks the language and changes the title accordingly.
     * @param {Object} questionModel - The question model.
     * @param {Object} sheet - The sheet object.
     * @returns {string} The modified title.
     */
    checkLanguageAndChangeTitle(questionModel, sheet) {
        const totalMarks = questionModel;
        const translatedMark = this.$translate.instant('CONTENT.MARK', { totalMarks: questionModel });

        if (this.$scope.langISO === 'sw_SW') {
            return ' (' + translatedMark + ' ' + totalMarks + ')';
        }

        return ' (' + totalMarks + ' ' + translatedMark + ')';
    }
}

/**
 * Registers the QuestionHeadline directive.
 * @param {Object} module - The Angular module.
 */
export default function registerQuestionHeadlineDirective(angular) {
    angular.module('assessmentFrontendDirectives').directive('questionHeadline', ['$bridges', '$routeParams', '$config', 'TaskInfoService', '$translate', '$signals',
        function ($bridges, $routeParams, $config, TaskInfoService, $translate, $signals) {
            return {
                restrict: 'E',
                replace: false,
                scope: {
                    question: '@',
                    containerheadline: '='
                },
                templateUrl: '/views/ib/components/QuestionHeadline.html',
                controller: ['$scope', '$element', '$bridges', 'TaskDataService', '$config', '$routeParams', 'TaskInfoService', '$translate', '$signals', QuestionHeadlineController]
            };
        }
    ]);
}